// extracted by mini-css-extract-plugin
export default {"bottom-sheet-content":"MethodSelection_bottom-sheet-content__zx5U0","bottom-sheet-body":"MethodSelection_bottom-sheet-body__lwiS+"};